export class StudyEventProcedure {
  constructor(params = {}) {
    this.id = params.id;
    this.studyProcedureDefinitionId = params.studyProcedureDefinitionId;
    this.studyEventDefinitionId = params.studyEventDefinitionId;
  }
}

export default StudyEventProcedure;
